<div class="long-time-loader non-blocking" [hidden]="!generatingDocument">
  <div class="status-text">
    <div class="spinner-border" role="status"></div>
    <div class="info-text">
      <b> {{ 'text.generatingDocument' | transloco: { name: docName } }} </b>
      {{ 'text.generatingDocumentInProgress' | transloco }}
    </div>
  </div>
</div>
